var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33917 8.49404C9.01374 8.1686 8.4861 8.1686 8.16066 8.49404L5.83325 10.8214L5.83325 1.16663C5.83325 0.706388 5.46016 0.333293 4.99992 0.333293C4.53968 0.333293 4.16658 0.706388 4.16658 1.16663L4.16658 10.8214L1.83917 8.49404C1.51374 8.1686 0.986098 8.1686 0.660662 8.49404C0.335225 8.81947 0.335225 9.34711 0.660662 9.67255L4.41066 13.4225C4.7361 13.748 5.26374 13.748 5.58917 13.4225L9.33917 9.67255C9.66461 9.34711 9.66461 8.81947 9.33917 8.49404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownWhite);
export default __webpack_public_path__ + "static/media/down-white.6ea0a807.svg";
export { ForwardRef as ReactComponent };